<div class="accordion-container">
  <header class="accordion-header" (click)="toggle()" role="button" tabindex="0" (keydown.enter)="toggle()"
    (keydown.space)="toggle()" [attr.data-testid]="headerTestId || null">
    <app-icon [name]="openState() ? openIcon : closeIcon" class="accordion-icon" data-testid="accordion-icon" />
    @if (headerText) {
    <span class="accordion-header-text" data-testid="accordion-header-text">{{ headerText }}</span>
    } @else if (headerContent) {
    <ng-container *ngTemplateOutlet="headerContent"></ng-container>
    }
  </header>
  @if (openState()) {
  <div class="accordion-content">
    <ng-content></ng-content>
  </div>
  }
</div>